// Reducer for calendar actions
import { saveAs } from 'file-saver'

import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'

export const DefaultCalendarState = {
}

export const DefaultCalendarDetailsState = {
  ...DefaultState
}

export const DefaultCalendarExportState = {
  ...DefaultState
}

const calendarDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultCalendarDetailsState,
  actionRequest: ActionTypes.REQUEST_CALENDAR,
  actionFailure: ActionTypes.REQUEST_CALENDAR_FAILURE,
  actionReceive: ActionTypes.RECEIVE_CALENDAR,
  actionInvalidate: ActionTypes.INVALIDATE_CALENDAR
})


export const calendarExport = (state = DefaultCalendarExportState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_CALENDAR_EXPORT:
      return {
        ...state,
        isFetching: true
      }
    case ActionTypes.RECEIVE_CALENDAR_EXPORT:
      saveAs(action.response, action.filename)
      return {
        ...state,
        isFetching: false,
        lastUpdated: action.receivedAt
      }
    case ActionTypes.REQUEST_CALENDAR_EXPORT_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        lastUpdated: action.receivedAt
      }
    default:
      return state
  }
}

export const calendar = (state = DefaultCalendarState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_CALENDAR:
    case ActionTypes.RECEIVE_CALENDAR:
    case ActionTypes.REQUEST_CALENDAR_FAILURE:
    case ActionTypes.INVALIDATE_CALENDAR:
      return {
        ...state,
        calendar: calendarDetails(state.list, action)
      }
    case ActionTypes.REQUEST_CALENDAR_EXPORT:
    case ActionTypes.RECEIVE_CALENDAR_EXPORT:
    case ActionTypes.REQUEST_CALENDAR_EXPORT_FAILURE:
      return {
        ...state,
        export: calendarExport (state.export, action)
      }
    default:
      return state
    }
}